import {FC} from 'react';

import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import {StatusHistoryRow} from './StatusHistoryRow';

import {IServiceRequestStatusHistory} from '../../../../../../shared/types/serviceRequest.types';

interface ITableBodyContainer {
  rowsPerPage: number;
  isLoading: boolean;
  statusHistory: IServiceRequestStatusHistory[];
}

export const TableBodyContainer: FC<ITableBodyContainer> = ({rowsPerPage, isLoading, statusHistory}) => {
  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows = rowsPerPage - statusHistory.length;

  return (
    <TableBody>
      {[...statusHistory]
        .sort((a, b) => {
          const aDate = new Date(a.date);
          const bDate = new Date(b.date);

          return aDate.getTime() - bDate.getTime() > 0 ? 1 : aDate.getTime() - bDate.getTime() < 0 ? -1 : 0;
        })
        .map((row) => {
          return <StatusHistoryRow key={row.date} row={row} />;
        })}
      {emptyRows > 0 && (
        <TableRow
          style={{
            height: 33.02 * emptyRows,
          }}
        >
          <TableCell align="center" colSpan={5}>
            {false && !false && 'Ничего не найдено'}
          </TableCell>
        </TableRow>
      )}
    </TableBody>
  );
};
